import { useEffect } from "react";
import { GeoJSON, Pane, useMap } from "react-leaflet";

export function FitBounds({ bounds }) {
  const map = useMap();
  useEffect(() => {
    if (bounds) map.fitBounds(bounds);
  }, [bounds, map]);
  return null;
}

// Thin, non-interactive outline of the 142 coarse cells, drawn on top of the
// fine-grid canvas so the coarse grid structure is always visible.
export function CoarseOutline({ fc, styleKey }) {
  if (!fc) return null;
  return (
    <Pane name="coarse-outline" style={{ zIndex: 450 }}>
      <GeoJSON
        key={`outline-${styleKey}`}
        data={fc}
        interactive={false}
        style={() => ({ color: "#33445c", weight: 0.7, opacity: 0.7, fill: false })}
      />
    </Pane>
  );
}

// Coarse choropleth (142 cells) with per-feature tooltip.
export default function CoarseLayer({ fc, styleKey, colorOf, tooltipHtml, outlineOnly }) {
  const map = useMap();
  useEffect(() => {
    // fit to data bounds on first render of a feature collection
  }, [map]);
  return (
    <GeoJSON
      key={styleKey}
      data={fc}
      style={(f) => ({
        fillColor: colorOf ? colorOf(f) : "#cccccc",
        color: "#33445c",
        weight: 0.6,
        fillOpacity: outlineOnly ? 0 : 0.74,
        fill: !outlineOnly,
      })}
      onEachFeature={(f, layer) => {
        if (tooltipHtml) {
          layer.bindTooltip(tooltipHtml(f), { sticky: true, className: "cidp-leaflet-tip" });
          layer.on("mouseover", () => layer.setStyle({ weight: 2.2, color: "#008eff" }));
          layer.on("mouseout", () => layer.setStyle({ weight: 0.6, color: "#33445c" }));
        }
      }}
    />
  );
}
